<template>
	<div class="dashboard_container prospective_student" aria-label="Prospective Student Dashboard Page Content">
		<div class="tfa-dashboard-section">
			<div class="top-section">

				<div class="row dashboard-row">

					<div class="col-xl-3 col-lg-5 col-md-6 col-sm-12 col-xs-12">
						<div class="row">
							<div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
								<div class="card ace_sec stud_summary" :aria-label="'Prospective Student. ' + username + ' summary'">
									<div class="card-body">
											<div class="notifications-row" tabindex="0">
													<div class="message-creator-avatar">
															<span class="ic6-user1"></span>
													</div>
													<div class="msg-section">
															<span class="usr_name" :title="username">{{username}}</span>
													</div>
											</div>
											<div>
												<div class="summary_sec">
														<div class="summary_sec_row ace_sec_txt row_major" :aria-label="'Major. ' + major">
																<span class="label">Major Interest: </span>
																<span class="value" v-if="major" :title="major">{{major}}</span>
																<span class="value no_info" v-else>- Undecided -</span>
														</div>
														<div v-if="career" class="summary_sec_row ace_sec_txt row_career" :aria-label="'Career Interest. ' + career">
																<span class="label">Career Interest: </span>
																<span class="value" :title="career">{{career}}</span>
														</div>
														<div v-if="recruiterName" class="summary_sec_row ace_sec_txt row_recruiter" :aria-label="'Advisor. ' + recruiterName">
																<span class="label">Advisor: </span>
																<span class="value" :title="recruiterName">{{recruiterName}}</span>
														</div>
												</div>
										 </div>

										 <div class="process">
											<!-- 20% Complete -->
										 </div>

										 <div class="edit-profile-link">
												<b-link :to="{ name: 'userProfile', params: { dashboardName: 'prospectiveStudentDashboard' }}" class="ace_sec_txt">edit profile</b-link>
										</div>
									</div>
								</div>
							</div>

              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
    						<div class="card ace_sec bookmarks" aria-label="Bookmarks">
    							<div class="card-header">
    									<span class="icon icon-bookmark"></span>
    									<span class="label ace_sec_hd" role="heading" aria-level="5" aria-label="Bookmarks">Bookmarks</span>
    									<div class="more-link test-link">
    										<b-link class="ace_sec_txt" :to="{ name: 'bookmarks'}">more</b-link>
    									</div>
    								</div>
    								<div class="card-body">

    									<template v-if="bookmarks && bookmarks.length === 0">
    										<div class="callout_help">
    											<span class="ic ic-idea"></span>

    											<div class="msg">
    												Looks like you are new here. Start exploring programs,
    												careers and insights and bookmark them by clicking the
    												bookmark icon for future reference.
    											</div>
    										</div>
    									</template>

    									<div class="card-content v_scroll">
    										<div class="bookmarks_sec">

    												<template v-if="bookmarks && bookmarks.length > 0">
    														<ul role="list">
    																<li v-for="bookmark in bookmarks">
    																		<a href="javascript:void(0);"  @click="goToBookmark(bookmark)">{{ bookmark.entityTitle }}</a>
    																</li>
    														</ul>
    												</template>

    										</div>
    										<!--
    										<div class="activity_sec">
    												<div>
    														<div class="mt-4">
    																Your Last Activity
    														</div>
    														<div class="mt-4">
    																<span class="mr-2 ace_sec_txt" aria-label="Your Last Activity">Continue Exploring Careers</span>
    																<span class="ml-2 ace_sec_txt"><button class="btn btn-primary" aria-label="click to continue on your last activity">Continue</button></span>
    														</div>
    												</div>
    										</div>
    										-->
    									</div>
    								</div>
    						</div>

					</div>

				</div>
        </div>
        <div class="col-xl-6 col-lg-7 col-md-6 col-sm-12 col-xs-12">
          <div class="card ace_sec dashboard_nav_container">
              <div class="card-body">

								<!--
                <div class="notifications-row ace_sec_txt" @click="navigateToExploreIntro">
                   <div class="message-creator-avatar"><span class="icon-explore"></span></div>
                     <div class="msg-section">
                       <div class="user-row">
                         <span class="user-name-section exp-name">Explore</span>
                       </div>
                     </div>
                 </div>
							 -->

                <div class="row nav_item program ace_sec_txt" @click="navigateToProgramGuideResults">
                  <div class="col-6">
										<div class="ic_container">
											<span class="ic ico-degreeProgram"></span>
										</div>
									</div>
                  <div class="col-6">
                    <div class="lnk_txt">
                      <span class="">Explore Programs</span>
                    </div>
                  </div>
                </div>

                <div class="row nav_item career ace_sec_txt" @click="navigateToCareerResults">
									<div class="col-6">
										<div class="ic_container">
											<span class="ic ico-career"></span>
										</div>
									</div>
									<div class="col-6">
                    <div class="lnk_txt">
                      <span class="">Explore Careers</span>
                    </div>
                  </div>
                </div>

                <div class="row nav_item insight ace_sec_txt" @click="navigateToInsights">
									<div class="col-6">
										<div class="ic_container">
											<span class="ic ico-insight"></span>
										</div>
									</div>
									<div class="col-6">
                    <div class="lnk_txt">
                      <span class="">Explore Insights</span>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>


					<div class="col-xl-3 col-lg-4 col-md-12 col-sm-12 col-xs-12 col_lg">
						<div class="rgt_pan" :class="isChannelEnabled ? 'two_row_col' : ''">
              <div class="card ace_sec" v-if="isChannelEnabled">
								<div class="card-header">
									<span class="icon icon-bell"></span>
									<span class="label ace_sec_hd">Notifications</span>
								</div>
								<div class="card-body">
									<div class="notifications-row" v-for="message in messages" style="cursor: default;">
										<div class="message-creator-avatar">
											<span class="ic6-user1"></span>
										</div>
										<div class="msg-section">
											<div class="user-row ace_sec_txt">
												<span class="user-name-section" :aria-label="message.name + ' add a message on ' + message.date">{{ message.name }}</span>
												<span class="time-section">{{ message.date }}</span>
											</div>
											<div class="msg-row ace_sec_txt" style="white-space: normal;" :aria-label="message.name + ' message. ' + message.text">
												{{ message.text }}
											</div>
										</div>
									</div>

									<div v-if="messages.length === 0" class="data_tbl_container">
										<div class="no_result" style="top: 30px;">No notifications found</div>
									</div>

								</div>
							</div>

							<div class="card ace_sec" aria-level="2" aria-label="Activity Section">
                <div class="card-header">
                  <span class="icon icon-activity" style="margin-top: -2px; margin-left: -2px; font-size: 42px;"></span>
                  <span class="label ace_sec_hd" role="heading" aria-label="Activity" style="width: 110px;">Reports</span>
									<div class="more-link">
                  	<b-link class="hd_lnk" @click="navigateToStreamReport()" style="margin-top: 5px;">more</b-link>
									</div>
                </div>
                <div class="card-body">
                  <template v-for="c in dashboardReports">
                    <div class="row report_sec_block" @click="navigateToStreamReport()">
                      <div class="col-12 hd ace_sec_hd" :aria-label="c.title">
          							<span>{{c.title}}</span>
          						</div>
                    	<div class="col-12">
                        <report :selectedReport="c" :type="c.visualizationType" :timeperiod="'all'"></report>
                      </div>
                    </div>
                  </template>
                  <template v-if="dashboardReports.length == 0">
                    <div class="row">
                      <div class="col-12">
                        <dummy-graph ref="DummyGraph"></dummy-graph>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
					</div>


        </div>

                <div class="dashboard-row col-xl-5 col-lg-6 col-md-12 col-sm-12 col-12">

                </div>



            </div>

						<b-modal ref="loadingProfileModal" centered hide-footer class="profile-new-popup" tabindex="1">
		    			<div slot="modal-header">
		    				<div class="checkbox-header">
		    					<input type="checkbox" v-model="isDoNotOpenProfilePopup" aria-label="Don't open the profile popup again">
		    					<div class="label-info" id="notShowAgain">Don't show me this again</div>
		    				</div>
		    				<div class="icon icon-mentor"></div>
		    				<b-btn
									size="sm"
									class="btn_close ace_sec_txt"
									variant="primary"
									@click="hideProfilePopup"
									aria-label="close profile popup">
										<span class="ic-close"></span>
								</b-btn>
		    			</div>

		    			<div class="content-section">
		    				<div class="left-col">
		    					<div class="thumbnail-row">
		    						<div class="default-thumbnail">
		                                <img :src="personProfile.thumbnailURI" v-if="profileLoaded && personProfile.thumbnailURI" class="profile-img">
		    							<div class="icon-mentor" v-else></div>
		    							<!--
		    							<div class="process">10% Complete</div>
		    							-->
		    						</div>
		    					</div>
		    				</div>

		    				<div class="right-col">
		    					<div class="field-section">
		    						<div class="field-row">
		    							<div class="field-title" id="majorValue">Major</div>
		    							<div class="field-form">
		    								<input type="text" class="input-search" aria-labelledby="majorValue" :value="major" disabled>
		    							</div>
		    						</div>
		    					</div>

		    					<div class="field-section">
		    						<div class="field-row">
		    							<div class="field-title" id="minorValue">Minor</div>
		    							<div class="field-form">
		    								<input type="text" class="input-search" aria-labelledby="minorValue" :value="minor" disabled>
		    							</div>
		    						</div>
		    					</div>

		    					<div class="field-section">
		    						<div class="field-row">
		    							<div class="field-title" id="concentrationValue">Concentration</div>
		    							<div class="field-form">
		    								<input type="text" class="input-search" aria-labelledby="concentrationValue" :value="concentration" disabled>
		    							</div>
		    						</div>
		    					</div>

		    	          		<div class="field-section">
		    						<div class="field-row">
		    							<div class="field-title" id="careerValue">Career Goal</div>
		    							<div class="field-form">
		    								<input type="text" class="input-search" aria-labelledby="careerValue" v-model="career">
		    							</div>
		    						</div>
		    					</div>

		    				</div>

		    				<div class="footer-row">
		    					<div class="info-row ace_sec_txt">We gathered some profile information from SIS. The more information you provide us the better we can help you explore programs and career interests Complete your profile now and then start exploring. </div>
		    					<div class="right-cols">
		    						<button class="btn ace_sec_txt" aria-label="complete your profile" @click="saveProfile">complete profile</button>
		    					</div>
		    				</div>

		    				<div class="footer-row footer-explore" v-if="isExplorePackageEnabled">
		    					<div class="info-row ace_sec_txt">Complete profile later. Start exploring programs and career interests now!</div>
		    					<div class="right-cols">
		    						<button class="btn ace_sec_txt" aria-label="start exploring now" @click="navigateToExplore"><i class="icon-explore"></i> start exploring now</button>
		    						<div class="dashboard-link">
		    							<a href="javascript:void(0);" class="ace_sec_txt" @click="hideProfilePopup" aria-label="start exploring now">No Thanks, Go to Dashboard</a>
		    						</div>
		    					</div>
		    				</div>
		    			</div>
            </b-modal>

        </div>

    </div>
</template>

<script>
  import '../../../assets/module/css/dashboard/tfaDashboard.min.css'
  import { mapState, mapActions } from 'vuex'
  import { PACKAGE } from '../../../package_constants'
  import { db } from '../../../firebase'
  import DummyGraph from './dummyGraph'
  import Report from '../../institution/components/Report'

  export default {
    name: 'admitted-student-dashboard',
    props: ['forceShowProfile'],
    components: {
      DummyGraph,
      Report
    },
    data: () => {
      return {
        uObj: JSON.parse(localStorage.getItem('userobj')),
        page: 0,
        pageSize: 100,
        career: '',
        isDoNotOpenProfilePopup: false,
        bookmarks: [],
        messages: [],
        currentChannel: '',
        personProfile: {},
        profileLoaded: false,
        userReports: []
      }
    },

    mounted () {
      this.loadStudentDashboard()
    },

    created () {
      this.currentChannel = this.planningStream.uuid
      this.$watch('planningStream', (planningStream) => {
        if (planningStream) {
          this.$bindAsArray('messages', db.ref('channels/' + planningStream.uuid + '/Messages'))
        }
      }, {
        immediate: true
      })
    },

    firebase: {
      messages: {
        source: db.ref('channels/' + this.currentChannel + '/Messages'),
        readyCallback: function () {
        },
        cancelCallback: function (e) {
          console.log('Could not get messages', e)
        }
      }
    },

    watch: {
      messages () {
        setTimeout(() => {
          var msgSectionHeight = $('.msg_section_inner_recommendation').innerHeight()
          $('.msg_row_section_recommendation').scrollTop(msgSectionHeight)
          var msgSectionHeight2 = $('.msg_section_inner_urgent').innerHeight()
          $('.msg_row_section_urgent').scrollTop(msgSectionHeight2)
        }, 100)
      },

      isDoNotOpenProfilePopup (newIsDoNotOpenProfilePopup) {
        this.loadSaveProfilePopup({isDoNotOpenProfilePopup: newIsDoNotOpenProfilePopup})
      },

      career (newCareer) {
        this.loadSaveProfileCareer({careerGoal: newCareer})
      }
    },

    methods: {
      ...mapActions([
        'loadBookmarks',
        'loadUserAdvisor',
        'loadUserCareerGoal',
        'loadUserPreferences',
        'loadLogDashboardActivity',
        'loadSaveProfileCareer',
        'loadSaveProfilePopup',
        'loadInstitutionPackage',
        'loadPersonProfile',
        'loadCareerUsingUuid',
        'loadProgramGuideUsingUuid',
        'loadUserReports',
        'loadPlanningStream'
      ]),
      navigateToStreamReport () {
        if (this.planningStream && this.planningStream.uuid)
          return this.$router.push({ name: 'streamReport', params: { uuid: this.planningStream.uuid } })
      },
      showProfilePopup () {
        this.$refs.loadingProfileModal.show()
      },
      hideProfilePopup () {
        this.loadLogDashboardActivity({action: 'closeProfilePopup', page: 'dashboard', link: ''})
        this.$refs.loadingProfileModal.hide()
      },
      closeNotificationPopup (index) {
        this.$refs['notificationPopover_' + index][0].$emit('close')
      },
      closeRecommendationPopup (index) {
        this.$refs['recommendationPopover_' + index][0].$emit('close')
      },
      async loadStudentDashboard () {
        const institutionId = this.institution.uuid || localStorage.getItem('institutionId')
        this.loadInstitutionPackage({uuid: institutionId, isAggregated: false}).then(res => {
          this.loadUserPreferences().then(res => {
            this.isDoNotOpenProfilePopup = res.doNotOpenProfilePopup
            if (this.isProfilePopupEnabled) {
              if (!this.isDoNotOpenProfilePopup || this.forceShowProfile) {
                this.showProfilePopup()
              }
            }
          })
        })
        await this.loadPlanningStream()
        this.userReports = await this.loadUserReports()
        this.loadBookmarks({page: this.page, count: this.pageSize, name: ''}).then(result => {
          result = (result && result.length > 0) ? result[0] : result
          this.bookmarks = result.content
        })
        this.loadLogDashboardActivity({action: 'viewDashboard', page: 'dashboard', link: ''})
        this.loadUserCareerGoal().then(res => {
          this.career = res
        })
        this.loadPersonProfile(this.uObj.uuid).then(res => {
          this.personProfile = res
          this.profileLoaded = true
        })
      },
      goToBookmark (bookmark) {
        if (bookmark.entityType === 'career') {
          // get career using UUID
          this.loadCareerUsingUuid(bookmark.entityUuid).then(career => {
            if (career.code) {
              let routerParams = { code: career.pragyaSoc, returnTo: 'bookmarks' }
              return this.$router.push({ name: 'careerDetail', params: routerParams })
            }
          })
        } else if (bookmark.entityType === 'programguide') {
          // get program guide using UUID
          this.loadProgramGuideUsingUuid(bookmark.entityUuid).then(programGuide => {
            if (programGuide && programGuide.cipCode) {
              let routerParams = { cipCode: programGuide.cipCode, programGuideCode: programGuide.code, type: programGuide.type, returnTo: 'bookmarks' }
              return this.$router.push({ name: 'programGuideIntroduction', params: routerParams })
            } else {
              return this.$notify({
                group: 'notify',
                type: 'warn',
                title: '',
                text: 'The selected Program Guide has no associated cip code. Unable to render page.'
              })
            }
          })
        } else if (bookmark.entityType === 'streams') {
          return this.$router.push({ name: 'streamTime', params: { uuid: bookmark.entityUuid } })
        } else if (bookmark.entityType === 'catalogs') {
          return this.$router.push({ name: 'catalogDetail', params: { uuid: bookmark.entityUuid, loadDataFromServer: true } })
        }
      },
      navigateToEntityPage (pageName, entityId) {
        this.$router.push({ name: pageName, params: { uuid: entityId } })
      },
      navigateToStream () {
        this.loadLogDashboardActivity({action: 'clickMore', page: 'dashboard', link: 'more'})
        return this.$router.push({ name: 'streamProgress', params: { uuid: this.planningStream.uuid } })
      },
      navigateToExplore () {
        this.loadLogDashboardActivity({action: 'clickExplore', page: 'dashboard', link: 'explore'})
        return this.$router.push({name: 'exploreIntro', params: {reload: true}})
      },
      navigateToPersonProfile () {
        if (this.personProfile) {
          this.loadLogDashboardActivity({action: 'clickPersonProfile', page: 'dashboard', link: 'explore'})
          return this.$router.push({name: 'personDetail', params: {uuid: this.personProfile.uuid, loadDataFromServer: true}})
        }
      },
      navigateToStreamTime () {
        this.loadLogDashboardActivity({action: 'clickMore', page: 'dashboard', link: 'more'})
        return this.$router.push({ name: 'streamTime', params: { uuid: this.planningStream.uuid } })
      },
      saveProfile () {
        this.loadLogDashboardActivity({action: 'saveProfilePopup', page: 'dashboard', link: ''})
        this.loadSaveProfileCareer({careerGoal: this.career})
        this.loadSaveProfilePopup({isDoNotOpenProfilePopup: this.isDoNotOpenProfilePopup})
        this.navigateToPersonProfile()
        this.$refs.loadingProfileModal.hide()
      },
      navigateToExploreIntro () {
        return this.$router.push({ name: 'exploreIntro' })
      },
      navigateToProgramGuideResults () {
        return this.$router.push({ name: 'exploreProgramGuideResults' })
      },
      navigateToCareerResults () {
        return this.$router.push({ name: 'exploreCareerResults' })
      },
      navigateToInsights () {
        return this.$router.push({ name: 'exploreInsightsResults' })
      }
    },

    computed: {
      ...mapState({
        'advisor': state => state.user.advisor,
        'careerGoal': state => state.user.careerGoal,
        'enabledFeatures': state => state.institution.enabledFeatures,
        'institution': state => state.institution.institution,
        'planningStream': state => state.dashboard.planningStream
      }),
      dashboardReports () {
        if (this.userReports.length > 0) {
          let dashboardReports = []
          this.userReports.forEach((item, i) => {
            if (item.showOnDashboard) {
              dashboardReports.push(item)
            }
          })
          return dashboardReports
        } else {
          return []
        }
      },
      messagesToShow () {
        let uMessages = []
        this.messages.forEach((message) => {
          if (message.type === 'Urgent Notification') {
            uMessages.push(message)
          }
        })
        return uMessages
      },
      username () {
        return localStorage.getItem('userFullName')
      },
      major () {
        if (this.uObj && this.uObj.major1Title) {
          return this.uObj.major1Title
        }
        return ''
      },
      minor () {
        if (this.uObj && this.uObj.minor1) {
          return this.uObj.minor1
        }
        return ''
      },
      concentration () {
        if (this.uObj && this.uObj.concentration1) {
          return this.uObj.concentration1
        }
        return ''
      },
      recruiterName () {
        if (this.advisor) {
          return this.advisor.name
        } else {
          return ''
        }
      },
      isProfilePopupEnabled () {
        let profilePopupFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.PROFILE_FEATURE_ID]
        if (profilePopupFeature) {
          return profilePopupFeature.enabled
        }
        return false
      },
      isExplorePackageEnabled () {
        let exploreFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_FEATURE_ID]
        if (exploreFeature && exploreFeature.enabled) {
          return true
        }
        return false
      },
      isChannelEnabled () {
        let channelFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.CHANNELS_FEATURE_ID]
        if (channelFeature) {
          return channelFeature.enabled
        }
        return false
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/app/dashboard/components/AdmittedStudentDashboard.vue